<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <div class="group-hinhanh">
                    <div class="wrap-custom-file" :class="slideImage.errorMessage ? 'input-valid-img-error' : ''">
                      <input @change="uploadImage($event)" type="file" name="image1" class="imgUploadOverview"
                             id="imgUpload" accept=".jpg,.png,.jpeg" :class="uploadImgInputClass"/>
                      <label
                        :style="slideImage.background != null ? 'background: url(' + slideImage.background + ')' : ''"
                        for="imgUpload" :class="slideImage.isLoadSuccess ? 'file-ok' : ''">
                        <i v-if="slideImage.isLoading" class="fa fa-spinner fa-spin"></i>
                        <span>{{ slideImage.name }}</span>
                      </label>
                    </div>
                    <div class="valid-error">{{ slideImage.errorMessage }}</div>
                  </div>
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                  <BaseSelect
                    :options="isActiveSelect.options"
                    :data="isActiveSelect.data"
                    ref="isActive"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-plus"></i> Thêm mới
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push('/slider-management/managed-sliders')"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";

export default {
  name: "CategoryAdd",
  components: {BaseSelect, BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      slideImage: {
        name: 'Chọn ảnh',
        isLoading: false,
        background: '',
        isLoadSuccess: false,
        isValid: true,
        errorMessage: '',
        data: {
          model: '',
          name: 'path',
        }
      },
      codeInput: {
        options: {
          label: "Mã Slider *",
          placeholder: "Mã Slider",
          type: "text",
          maxLength : 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã Slider không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên Slider *",
          placeholder: "Tên Slider",
          type: "text",
          maxLength : 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên Slider không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: '1'
        }
      }
    };
  },
  methods: {
    uploadImage: function (e) {
      let that = this;
      let reader = new FileReader();
      let objectResult = {};
      let dataFile = e.target.files[0];
      reader.readAsDataURL(dataFile);
      that.slideImage.isLoading = true;
      that.slideImage.name = null;
      reader.onload = function () {
        setTimeout(function () {
          objectResult.fileName = dataFile.name;
          let readerResult = reader.result;
          objectResult.content = readerResult.split(',')[1];
          that.slideImage.data.model = objectResult;
          that.slideImage.background = readerResult;
          that.slideImage.isLoading = false;
          that.slideImage.isLoadSuccess = true;
          that.slideImage.name = dataFile.name;
          that.validSlideImage(true);
        }, 500);
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
      };
    },
    validSlideImage: function (isAsync) {
      let that = this;
      // eslint-disable-next-line no-undef
      let file = $('#imgUpload').get(0).files && $('#imgUpload').get(0).files.length != 0;

      function excute() {
        if (file) {
          let type = $('#imgUpload').get(0).files[0].type;
          if (type != 'image/jpg' && type != 'image/jpeg' && type != 'image/png') {
            that.slideImage.isValid = false;
            that.slideImage.errorMessage = 'Sai định dạng file';
          } else {
            that.slideImage.isValid = true;
            that.slideImage.errorMessage = '';
          }
        } else {
          that.slideImage.isValid = false;
          that.slideImage.errorMessage = 'Chọn ảnh slide';
        }
      }

      if (isAsync) {
        setTimeout(function () {
          excute();
        }, 50);
      } else {
        excute();
      }
    },
    submitData: function () {
      let that = this;
      this.validSlideImage();
      let isValid = true;
      isValid &= that.slideImage.isValid;
      isValid &= that.codeInput.data.validator.valid();
      isValid &= that.nameInput.data.validator.valid();
      if (!isValid) {
        return;
      } else {
        let dataRequest = {};
        dataRequest.path = that.slideImage.data.model;
        dataRequest.code = that.codeInput.data.model;
        dataRequest.name = that.nameInput.data.model;
        dataRequest.active = that.isActiveSelect.data.model;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/slide/createSlide",
          dataSubmit: function () {
            return dataRequest;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({message: "Thêm mới slider thành công"});
              // that.$router.go(-1);
              that.$router.push('/slider-management/managed-slider/' +response.data.data.id)
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    },
  },
  computed: {
    uploadImgInputClass: function () {
      return {
        valid: this.slideImage.isValid,
        'un-valid': !this.slideImage.isValid
      }
    },
  },
  created() {
  },
  mounted() {
  },
  watch: {}
};
</script>
